import Openable from './lib/openable';

class Modal extends Openable {
  constructor(element, overlay) {
    super(element, overlay);

    this.classes = {
      active: 'modal--active',
    };
  }
}

export default (element, overlay) => new Modal(element, overlay);
